module.exports = __webpack_public_path__ + "static/media/arrow_left_yellow.0cebab54.svg";